import './react-pro-sidebar.css';
import Authorize from 'components/common/authorize';
import React, { useRef } from 'react';
import UserProfile from 'components/layout/user-profile';
import moment from 'moment';
import { APPS, PERMISSIONS, ROLES } from 'components/constants';
import { Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar, } from 'react-pro-sidebar';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import _ from 'lodash';

export default function SideMenu(props) {

    const ref = useRef(null);
	const params = useParams();

    const settings = useSelector((store) => store.settings.settings);
	const userPermissions = useSelector(store => store.users?.user_permissions);

    const { collapseSidebar, collapsed } = useProSidebar();
    const customerAssetsEnabled = settings?.features?.assets?.customer_assets;
    const settingsPermissions = _.chain(Object.values(PERMISSIONS)).filter((item) => item.group == 'settings').orderBy(['order'], ['asc']).value();

    var firstAuthorizedSetting = null;
    settingsPermissions?.forEach((perm) => {
        if (userPermissions[perm.key] && !firstAuthorizedSetting) firstAuthorizedSetting = perm.page;
    });
    if (!firstAuthorizedSetting) firstAuthorizedSetting = 'user_preferences';

    return (

        <div ref={ref} style={{ display: 'flex', height: '100%', position: 'absolute', zIndex: 1999 }}>
            <Sidebar
                width={'220px'}
                style={{ height: '100vh' }}
                defaultCollapsed={false}
                collapsedWidth='80px'
                backgroundColor='#2f4050'
            >
                <div style={{ minHeight: '195px', marginBottom: '20px' }} >
                    <UserProfile container={ref} collapsed={collapsed} />
                </div>
                <Menu iconShape="circle" closeOnClick={true}>

                    <Authorize perm={ PERMISSIONS.DASHBOARD_VIEW }>
                        <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/dashboard`)}
                            icon={<i className="fa-solid fa-gauge fa-xl"></i>}
                            component={<Link replace to={`/${props.handleApp}/dashboard`} />}
                        >DASHBOARD</MenuItem>
                    </Authorize>

                    <Authorize feature={'service_schedule'} perm={ PERMISSIONS.SCHEDULE_VIEW }>
                        <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/schedule`)}
                            icon={<i className="fa-solid fa-calendar-days fa-xl"></i>}
                            component={<Link replace to={`/${props.handleApp}/schedule/${moment().format('YYYY-MM-DD')}`} />}
                        >SCHEDULE</MenuItem>
                    </Authorize>

                    <Authorize feature={'service_map'} perm={ PERMISSIONS.SERVICE_MAP_VIEW }>
                        <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/map`)}
                            icon={<i className="fa-solid fa-map-location-dot fa-xl"></i>}
                            component={<Link replace to={`/${props.handleApp}/map/0/${moment().format('YYYY-MM-DD')}`} />}
                        >SERVICE MAP</MenuItem>
                    </Authorize>

                    { (params.appId == APPS.DISPATCH.id || customerAssetsEnabled) &&
                        <Authorize perm={ PERMISSIONS.CUSTOMERS_VIEW }>
                            <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/customers`)}
                                icon={<i className="fa-solid fa-users fa-xl"></i>}
                                component={<Link  replace to={`/${props.handleApp}/customers`} />}
                            >CUSTOMERS</MenuItem>
                        </Authorize>
                    }  

                    { params.appId == APPS.ASSETS.id &&
                        <Authorize appId={ APPS.ASSETS.id } perm={ PERMISSIONS.ASSETS_VIEW }>
                            <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/assets`)}
                                icon={<i className="fa-regular fa-circle-small fa-xs"></i>}
                                component={<Link replace to={`/${props.handleApp}/assets`} />}        
                            >ASSETS</MenuItem>
                        </Authorize>
                    }

                    { params.appId == APPS.ASSETS.id &&
                        <Authorize appId={ APPS.ASSETS.id } perm={ PERMISSIONS.USERS_VIEW }>
                            <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/users`)}
                                icon={<i className="fa-regular fa-circle-small fa-xs"></i>}
                                component={<Link replace to={`/${props.handleApp}/users/0/overview`} />}        
                            >SHARED ACCESS</MenuItem>
                        </Authorize>
                    }

                    <Authorize perm={ PERMISSIONS.INVENTORY_VIEW }>
                        <SubMenu label="INVENTORY" icon={ <i className="fa-solid fa-scanner-gun fa-xl"></i> }>
                            <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/inventory`)}
                                icon={<i className="fa-regular fa-circle-small fa-xs"></i>}
                                component={<Link replace to={`/${props.handleApp}/inventory`} />}
                            >INVENTORY</MenuItem>
                            <Authorize perm={ PERMISSIONS.VENDORS_VIEW }>
                                <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/vendors`)}
                                    icon={<i className="fa-regular fa-circle-small fa-xs"></i>}
                                    component={<Link replace to={`/${props.handleApp}/vendors`} />}
                                >VENDORS</MenuItem>
                            </Authorize>
                        </SubMenu>
                    </Authorize>

                    <Authorize perm={ PERMISSIONS.EMPLOYEES_VIEW }>
                        <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/employees`)}
                            icon={<i className="fa-solid fa-user-clock fa-xl"></i>}
                            component={<Link replace to={`/${props.handleApp}/employees/0/overview`} />}
                        >EMPLOYEES</MenuItem>
                    </Authorize>

                    <div style={{ height: '200px' }}></div>

                    {/* <div className="mb-5"></div> */}

                    <Authorize perm={ PERMISSIONS.ARCHIVES_VIEW }>
                        <MenuItem rootStyles={{ position: 'fixed', width: '200px', left: 0, bottom: 90, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}
                            active={props.location.pathname.startsWith(`/${props.handleApp}/archive`)}
                            icon={<i className="fa-solid fa-box-archive fa-xl"></i>}
                            component={<Link to={`/${props.handleApp}/archive`} />}
                        >ARCHIVE</MenuItem>
                    </Authorize>
                    
                    <MenuItem active={props.location.pathname.startsWith(`/${props.handleApp}/settings`)}
                        rootStyles={{ position: 'fixed', width: '200px', left: 0, bottom: 40}}
                        icon={<i className="fa-solid fa-gear fa-xl"></i>}
                        component={<Link to={`/${props.handleApp}/settings/${firstAuthorizedSetting}`} />}
                    >SETTINGS</MenuItem>
                    <MenuItem 
                        rootStyles={{ position: 'fixed', width: '200px', height: '35px', left: 0, bottom: 10 }}
                        component={<div />}
                    >{window.build}</MenuItem>
                </Menu>
                {/* <main style={{ position: 'fixed', left: 10, bottom: 25 }}>
                    <center>
                        {window.build}
                    </center>
                </main> */}
            </Sidebar>
        </div>
    );
}
